import { create } from 'zustand';

import type { ImportSectionDrawerStore, OnImportCallback } from './types';

export const useImportSectionDrawer = create<ImportSectionDrawerStore>(set => ({
  isOpen: false,
  onImport: undefined,
  openDrawer: (callback: OnImportCallback) => set({ isOpen: true, onImport: callback }),
  closeDrawer: () => set({ isOpen: false, onImport: undefined })
}));
